import { render } from "./perceraian.vue?vue&type=template&id=21288d4e&scoped=true"
import script from "./perceraian.vue?vue&type=script&lang=js"
export * from "./perceraian.vue?vue&type=script&lang=js"

import "./perceraian.vue?vue&type=style&index=0&id=21288d4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21288d4e"

export default script